
export const bookingPalette = [
    'rgba(25, 97, 144, 0.08)',   // Light Blue
    'rgba(16, 185, 129, 0.08)',  // Light Green
    'rgba(130, 123, 51, 0.08)',  // Light Olive
    'rgba(181, 64, 64, 0.08)',   // Light Red
    'rgba(122, 102, 212, 0.08)', // Light Purple
];

export const getBookingStats = (rows = []) => {
    const map = {};
    rows.forEach(r => {
        const id = r?.orderId?._id;
        if (!id) return;
        map[id] = (map[id] || 0) + 1;
    });
    return map;
};

export const getBookingColorMap = (rows = []) => {
    const colorMap = {};
    let i = 0;
    rows.forEach(r => {
        const id = r?.orderId?._id;
        if (!id) return;
        if (!colorMap[id]) {
            colorMap[id] = bookingPalette[i % bookingPalette.length];
            i++;
        }
    });
    return colorMap;
};
